const ROOT = 'dashboard/settings/properties/domus/'

export default {
	show: `${ROOT}show-on-domus/`
}
